<template>
  <v-card
      class="px-3 py-4 oder-box-products"
      outlined
      tile
  >
    <div class="align-start d-flex justify-space-between">
      <div
          style="color: #ac0606; font-weight: 600; font-size: 14px"
          class="d-flex pl-3 mb-6"
      >
        <div style="width: 150px">Sản phẩm khóa học</div>
        <div class="d-flex pl-6">
          <v-checkbox
              label="Bán mới"
              hide-details
              class="table-layout-checkbox ma-0 pa-0"
              v-model="product.isNew"
              :disabled="isDetailOrder"
              @change="clickNew(product)"
          />
          <v-checkbox
              label="Gia hạn"
              hide-details
              class="table-layout-checkbox ma-0 pa-0 ml-6"
              v-model="product.isExtend"
              :disabled="isDetailOrder"
              @change="clickExtend(product)"
          />
        </div>
      </div>
      <div v-if="!isDetailOrder" class="d-flex mt-1">
        <div @click="deleteProduct(product, indexProd)" class="cursor-pointer">
          <svg
              width="14"
              height="16"
              viewBox="0 0 14 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
          >
            <path
                d="M4.4987 0.927734V1.76107H0.332031V3.42773H1.16536V14.2611C1.16536 14.7031 1.34096 15.127 1.65352 15.4396C1.96608 15.7521 2.39 15.9277 2.83203 15.9277H11.1654C11.6074 15.9277 12.0313 15.7521 12.3439 15.4396C12.6564 15.127 12.832 14.7031 12.832 14.2611V3.42773H13.6654V1.76107H9.4987V0.927734H4.4987ZM2.83203 3.42773H11.1654V14.2611H2.83203V3.42773ZM4.4987 5.0944V12.5944H6.16536V5.0944H4.4987ZM7.83203 5.0944V12.5944H9.4987V5.0944H7.83203Z"
                fill="#AC0606"
            />
          </svg>
        </div>
      </div>
    </div>
    <v-row>
      <v-col cols="12" class="py-0">
        <v-simple-table class="table-layout table-order-custom-tutor">
          <thead>
          <tr>
            <th class="col-product text-left" style="font-size: 12px !important; width: 50% !important;">SẢN PHẨM</th>
            <th class="col-price text-left" style="font-size: 12px !important; width: 20% !important;">ĐƠN GIÁ</th>
            <th class="col-product text-left" style="font-size: 12px !important; width: 30% !important;">PHƯƠNG THỨC KÍCH HOẠT</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>
              <validation-provider
                  v-slot="{ errors }"
                  :name="`Sản phẩm ${indexProd + 1}`"
                  :rules="{ required: true }"
              >
                <v-autocomplete
                    :items="product.products"
                    :error-messages="errors"
                    item-value="id"
                    item-text="name"
                    :aLight="'right'"
                    placeholder="Chọn"
                    label=""
                    style="padding: 0 !important; font-size: 14px !important;"
                    auto
                    :disabled="isDetailOrder"
                    :menu-props="{
                            top: true,
                            offsetY: true,
                            maxHeight: '310',
                          }"
                    @change="onSelectProduct(product)"
                    v-model="product.productId"
                >
                  <template slot="selection" slot-scope="data">
                            <span v-if="innerWidth > 1440">{{
                                data.item.name.length > 120
                                    ? `${data.item.name.slice(0, 120)}...`
                                    : data.item.name
                              }}</span>
                    <span v-else>{{
                        data.item.name.length > 40
                            ? `${data.item.name.slice(0, 40)}...`
                            : data.item.name
                      }}</span>
                  </template>
                  <template slot="item" slot-scope="data">
                    <div>
                              <span
                                  style="font-weight: bold; font-size: 14px"
                              >{{ data.item.name }}</span
                              >

                      <div class="text-muted d-flex">
                        <v-icon color="#564F4C">
                          mdi-circle-small
                        </v-icon>
                        <span
                            style="font-style: italic; font-size: 10px"
                        >{{ subjectObj[data.item.subjectId] }} -
                                  {{ levelObj[data.item.level] }}</span
                        >
                      </div>
                      <div class="text-muted d-flex">
                        <v-icon color="#564F4C">
                          mdi-circle-small
                        </v-icon>
                        <span
                            style="font-style: italic; font-size: 10px"
                        >
                                  Lớp
                                  <span
                                      v-for="(grade, index) in sortData(
                                      data.item.gradeIds
                                    )"
                                      :key="'grade' + grade"
                                  >{{ gradeObj[grade] }}
                                    {{
                                      index === data.item.gradeIds.length - 1
                                          ? ""
                                          : ", "
                                    }}</span
                                  >
                                  -
                                  {{
                            data.item.durationType === "month"
                                ? `${data.item.duration} tháng`
                                : `${formatDateDMY2(data.item.endDate)}`
                          }}
                                </span>
                      </div>
                    </div>
                  </template>
                </v-autocomplete>
              </validation-provider>
            </td>
            <td class="text-left" style="padding-top: 0px !important;">
              <template v-if="isConversionMonth">
                <div style="border-bottom: 1px solid #d2d2d2;padding-bottom: 4px">
                  --
                </div>
              </template>
              <template v-else>
                <div style="border-bottom: 1px solid #d2d2d2;padding-bottom: 4px"
                     v-if="product.priceType && product.priceType === 'unchanged'"
                >
                  {{
                    product.price || product.price === 0
                        ? formatCurrency(product.price)
                        : '-'
                  }}
                </div>
                <validation-provider
                    v-else
                    v-slot="{ errors }"
                    :name="`Đơn giá ${indexProd + 1}`"
                    :rules="{
                    required: true,
                    max_value: product.maxPrice,
                    min_value: product.minPrice,
                  }"
                >
                  <v-text-field
                      :disabled="isDetailOrder"
                      label=""
                      :error-messages="errors"
                      :placeholder="
                      product.productId
                        ? `${formatCurrency(
                            product.minPrice
                          )} - ${formatCurrency(product.maxPrice)}`
                        : 'Nhập số tiền'
                   "
                      dense
                      style="padding-top: 0 !important;"
                      type="number"
                      v-model="product.price"
                  ></v-text-field>
                </validation-provider>
              </template>
            </td>
            <td>
              <validation-provider
                  v-slot="{ errors }"
                  :name="`Phương thức ${indexProd + 1}`"
                  :rules="{ required: true }"
              >
                <v-autocomplete
                    :disabled="isDetailOrder"
                    :items="getActivationTypes(product)"
                    :error-messages="errors"
                    :aLight="'right'"
                    placeholder="Chọn"
                    label=""
                    style="padding: 0 !important; font-size: 14px !important;"
                    :menu-props="{
                            top: true,
                            offsetY: true,
                            maxHeight: '310',
                          }"
                    v-model="product.activeType"
                >
                  <template slot="selection" slot-scope="data">
                    <span>{{ activeTypeObj[data.item] }}</span>
                  </template>
                  <template slot="item" slot-scope="data">
                    <span>{{ activeTypeObj[data.item] }}</span>
                  </template>
                </v-autocomplete>
              </validation-provider>
              <div
                  v-if="product.activeType === 'student_self_activation'"
                  class="text-left"
                  style="color: red; margin-top: -20px"
              >
                Thời gian chờ tối đa 1 năm
              </div>
            </td>
          </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import {formatCurrency, formatDateDMY2} from "../../../helper/FuncProduct";
import _ from "lodash";

export default {
  props: {
    isConversionMonth: {
      type: Boolean,
      default: false,
    },
    product: {
      type: Object,
      default: () => ({}),
    },
    indexProd: {
      type: Number,
      default: 0,
    },
    subjectObj: {
      type: Object,
      default: () => ({}),
    },
    levelObj: {
      type: Object,
      default: () => ({}),
    },
    gradeObj: {
      type: Object,
      default: () => ({}),
    },
    activeTypeObj: {
      type: Object,
      default: () => ({}),
    },
    innerWidth: {
      type: Number,
      default: 0,
    },
    skuDuos: {
      type: Array,
      default: () => [],
    },
    isDetailOrder: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    formatDateDMY2,
    formatCurrency,
    onSelectProduct(product){
      const productSelected = product.products.find((item) => item.id === product.productId);
      product.productID = productSelected.productId;
      product.productName = productSelected.name;
      product.subjectId = productSelected.subjectId;
      if ( product.type === 'duo' ) {
        product.quantity = 1;
        product.durationType = productSelected.durationType;
        product.activeType = productSelected.activationTypes && productSelected.activationTypes.length ? productSelected.activationTypes[0] : null;
      }
      product.duration = productSelected.duration;
      product.productCode = productSelected.code;
      product.campaigns = [];
      product.endDate = productSelected.endDate;
      if (productSelected.pricePolicies.length) {
        product.priceType = productSelected.pricePolicies[0].priceType;
        product.price = null;
        if (productSelected.pricePolicies[0].priceType == 'unchanged') {
          product.price = productSelected.pricePolicies[0].minPrice;
        }else if(productSelected.pricePolicies[0].priceType == 'custom') {
          product.price = productSelected.pricePolicies[0].maxPrice;
        }
        product.maxPrice = productSelected.pricePolicies[0].maxPrice;
        product.minPrice = productSelected.pricePolicies[0].minPrice;
      }else {
        product.price =   productSelected.orgPrice;
      }
    },

    getActivationTypes(product) {
      const data = product.products.find(item => item.id === product.productId);
      if (data) {
        return data.activationTypes;
      }
      return [];
    },

    clickNew(product) {
      product.isExtend = false
      product.campaigns = [];
    },
    clickExtend(product) {
      product.isNew = false;
      product.campaigns = [];
    },

    deleteProduct(product, index) {
      this.$emit("deleteProduct", { product, index });
    },

    sortData(data) {
      const dataSort = _.cloneDeep(data);
      dataSort.sort((a, b) => a.localeCompare(b, undefined, {numeric: true}))
      return dataSort;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep.v-input__control {
  min-height: 10px;
}

::v-deep .v-data-table th {
  font-size: 16px !important;
}
::v-deep .v-data-table td,
::v-deep .v-data-table table thead tr th {
  font-size: 14px !important;
  padding: 10px 12px !important;
  padding-bottom: 0 !important;
}
.price {
  background: #d9d9d9;
  border: 1px solid rgba(0, 0, 0, 0.4);
  padding: 5px;
  font-weight: 400;
  height: 38px;
  line-height: 28px;
  border-radius: 4px;
}
::v-deep
.v-text-field--outlined.v-input--dense.v-text-field--outlined
> .v-input__control
> .v-input__slot {
  min-height: 38px !important;
}

.table-order-custom-tutor {
  th {
    min-width: 100px !important;
    padding-bottom: 0 !important;
    height: 24px !important;
  }
  .col-program {
    width: 240px;
  }
  .col-teacher {
    width: 100px;
  }
  .col-package {
    width: 120px;
  }
  .col-product {
    width: 210px;
  }
  .col-count {
    min-width: 60px !important;
    width: 85px !important;
  }
  .col-price {
    width: 150px;
  }
  .col-discount {
    width: 100px;
  }
  .col-total {
    width: 100px;
  }
  .col-child {
    min-width: 120px !important;
    width: 120px !important;
  }
  .text-muted {
    color: #564f4c;
    font-size: 10px;
  }
}
.table-layout {
  th {
    border-bottom: none !important;
  }
}
.select-customer ::placeholder {
  color: rgb(172, 6, 6) !important;
  font-style: italic;
  font-size: 13px;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
